import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from 'redux';
import type { AnyAction, Reducer, Store, StoreEnhancer } from 'redux';
import { createLogger } from 'redux-logger';
import { thunk } from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import { history, routerMiddleware, startRouterListener } from './Router';

import createRootReducer from './reducers';
import type { RootState } from './reducers';
import rootSaga from './sagas';
import allThunks from './thunks';
import { registerCreators } from './IndirectThunks';
import { initSocket } from '../api/Socket';
import { setStore } from './storeRef';

export type AppStore = Store<RootState, AnyAction>;
export type AppDispatch = AppStore['dispatch'];
type CreateAppStore = (
  reducer: Reducer<RootState, AnyAction>,
  preloadedState: RootState | undefined,
  enhancer: StoreEnhancer
) => AppStore;
const createAppStore = createStore as unknown as CreateAppStore;

registerCreators(allThunks);
const sagaMiddleware = createSagaMiddleware();
const logger = createLogger();
export { history };

const middleware = [
  routerMiddleware, // for dispatching history actions
  // ... other middlewares ...
  thunk,
  sagaMiddleware,
  logger,
];

// Be sure to ONLY add this middleware in development!
// if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_IMMU_CHECK) {
//   console.log('Enabling Redux immutability checks');
//   //middleware.unshift(require('redux-immutable-state-invariant').default());
// }

function configureStore(preloadedState?: RootState): AppStore {
  const rootReducer = createRootReducer() as unknown as Reducer<
    RootState,
    AnyAction
  >;
  const enhancer = compose(applyMiddleware(...middleware)) as StoreEnhancer;
  const store = createAppStore(
    rootReducer, // root reducer with router state
    preloadedState,
    enhancer
  );

  sagaMiddleware.run(rootSaga);
  startRouterListener(store);

  return store;
}

const store = configureStore();

// To avoid cyclic dependencies, inject the store after creation
setStore(store);
initSocket(store);

export default store;
